@import '@hevoio/hevo-ui-toolkit/styles/variables';

.modalPaper {
  background: $surface-bg !important;
}

.setupGuideDocs {
  width: 40%;
  min-width: 360px;
  border-left: $border-width solid $stroke-soft-200;
}

.formFields {
  display: flex;
  flex-direction: column;
  gap: $spacer-16;
}

.noticeBanner {
  display: flex;
  align-items: flex-start;
  gap: $spacer-8;
  padding: $spacer-10 $spacer-16;
  margin-bottom: $spacer-4;
  border-radius: $border-radius-6;
  background-color: var(--surface-bg-alternate-color);
  font-size: $font-size-body;
  line-height: $line-height-body;
  color: $text-sub-600;
}

.noticeBannerIcon {
  flex-shrink: 0;
}

.noticeBannerDetail {
  margin: $spacer-4 0 0;
  font-size: $font-size-body;
  color: $text-soft-400;
  word-break: break-word;
}
